module.exports = __webpack_public_path__ + "img/blocks-shuffle.95c2ff28.svg";